module.exports = __webpack_public_path__ + "img/manuelselman.918aeb8e.jpg";